import SecureLS from 'secure-ls';

const secureLs = new SecureLS({ encodingType: 'aes' });

const secureStorage = {
  getItem: (key: string): string | null => {
    return secureLs.get(key) || null;
  },
  setItem: (key: string, value: unknown): void => {
    secureLs.set(key, value);
  },
  removeItem: (key: string): void => {
    secureLs.remove(key);
  },
  clear: (): void => {
    secureLs.removeAll();
  },
};

export default secureStorage;
